// src/dataservice.js
// Update DATA_URL if you serve the file from a different path.
export const DATA_URL = '/data/all_data.json';
export const API_BASE_URL = '/api'; // Using a proxy for development

function normalizeRecord(r){
  const n = { ...r };
  if (n['Performer.1'] && !n['Performer_1']) {
    n['Performer_1'] = n['Performer.1'];
    delete n['Performer.1'];
  }
  // Ensure numeric types
  // The backend now returns correct types from BigQuery, but this is good for safety.
  ['year','avg_value','p10_value','p90_value'].forEach(k=>{
    if (r[k] === null || r[k] === undefined || r[k] === '') return;
    const v = Number(r[k]);
    r[k] = Number.isFinite(v) ? v : null;
  });
  return r;
}

export async function fetchDims() {
  const url = `${API_BASE_URL}/dims`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    return await res.json();
  } catch (e) {
    throw new Error(`Failed to fetch dimensions: ${e.message}`);
  }
}

export async function fetchTA1(filters, chartSettings, isBenchmark = false) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (Array.isArray(value)) {
      value.forEach(v => params.append(key, v));
    } else if (value !== null && value !== undefined && value !== '') {
      params.append(key, value);
    }
  }

  if (chartSettings) {
    for (const [key, value] of Object.entries(chartSettings)) {
      if (value) {
        params.append(key, value);
      }
    }
  }

  if (isBenchmark) {
    params.append('benchmark', 'true');
  }

  const url = `${API_BASE_URL}/data?${params.toString()}`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    const raw = await res.json();
    return raw.map(normalizeRecord);
  } catch (e) {
    throw new Error(`Failed to fetch TA1 data: ${e.message}`);
  }
}

export async function fetchTungstenFlows() {
  const url = '/data/rovjok_tungsten_material_flow.json';
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    const raw = await res.json();
    return raw.map(normalizeFlowRecord);
  } catch (e) {
    throw new Error(`Failed to fetch tungsten flow data: ${e.message}`);
  }
}

function normalizeFlowRecord(r) {
  const n = { ...r };
  // Ensure numeric types for flow data
  ['value', 'year', 'valueUsd', 'weightTonnes'].forEach(k => {
    if (n[k] === null || n[k] === undefined || n[k] === '') return;
    const v = Number(n[k]);
    n[k] = Number.isFinite(v) ? v : null;
  });
  return n;
}